/** Stable Vercel production URL — TLS works on all networks (fallback only) */
export const VERCEL_PRODUCTION_ORIGIN = 'https://soccer-app-gules.vercel.app';

export const DAILY_SPORTS_LIFE_WWW = 'https://www.dailysportslife.com';

const HOST_CANONICAL_ORIGINS = {
  'dailysportslife.com': DAILY_SPORTS_LIFE_WWW,
};

export function isDailySportsLifeHost() {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host === 'dailysportslife.com' || host === 'www.dailysportslife.com';
}

/**
 * Canonical origin for SEO (og:url, link rel=canonical). Always prefers the custom
 * domain in production so Google and social crawlers consolidate on one hostname.
 */
export function getCanonicalSiteOrigin() {
  const configured =
    process.env.REACT_APP_CANONICAL_ORIGIN || process.env.REACT_APP_SITE_URL;
  if (configured && typeof configured === 'string' && configured.trim()) {
    return configured.trim().replace(/\/+$/, '');
  }

  if (process.env.NODE_ENV === 'production') {
    return DAILY_SPORTS_LIFE_WWW;
  }

  if (typeof window === 'undefined') {
    return '';
  }

  const canonical = HOST_CANONICAL_ORIGINS[window.location.hostname];
  if (canonical) {
    return canonical;
  }

  return window.location.origin;
}

/**
 * Origin for share/copy links (WhatsApp, clipboard).
 * Defaults to www.dailysportslife.com for SEO. Set REACT_APP_SHARE_FALLBACK_ORIGIN to
 * https://soccer-app-gules.vercel.app only if you need emergency fallback links.
 */
export function getShareOrigin() {
  const fallback = process.env.REACT_APP_SHARE_FALLBACK_ORIGIN;
  if (fallback && typeof fallback === 'string' && fallback.trim()) {
    return fallback.trim().replace(/\/+$/, '');
  }

  return getCanonicalSiteOrigin();
}
